<script lang="ts" setup>
	defineProps<{
		title?: string
		paragraph?: string
	}>()
</script>

<template>
	<div class="min-h-[200px] space-y-5 rounded p-5 tracking-wide sm:p-8">
		<slot>
			<h3 class="text-xl font-semibold text-gray-800 sm:text-[28px]">
				<slot name="title">
					{{ title }}
				</slot>
			</h3>
			<p class="leading-[18px] text-gray-600 sm:text-base">
				<slot name="paragraph">
					{{ paragraph }}
				</slot>
			</p>
		</slot>
	</div>
</template>
